import React from 'react';
import passengerIcon from '../../../../assets/images/icons/psg-number.svg';
import luggageIcon from '../../../../assets/images/icons/luggageIcon.svg';

const CapacityDisplay = ({ passengers, luggage }) => (
  <div className="car-capacity">
    <span className="capacity-item">
      <img src={passengerIcon} alt="passengers" className="capacity-icon" />
      <span>{passengers}</span>
    </span>
    <span className="capacity-item">
      <img src={luggageIcon} alt="luggage" className="capacity-icon" />
      <span>{luggage}</span>
    </span>
  </div>
);

export default CapacityDisplay;